import { Helmet } from 'react-helmet-async'

import { faHome } from '@fortawesome/pro-light-svg-icons'

import { Box, Columns, LoadingModule } from '@domain-group/suit-theme'

import useAgencyMarketing from '@hooks/useAgencyMarketing'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import AllTags from '../AllTags'
import FeaturedTags from '../FeaturedTags'
import TagSearch from '../TagSearch'
import RecentCampaigns from '../RecentCampaigns'

const PageContent = () => {
  const agencyMarketingPayload = useAgencyMarketing()
  const {
    callbacks: { selectTag },
    tagsPayload: {
      loading,
    },
    urls: { agencyMarketingIndexUrl },
  } = agencyMarketingPayload

  return (
    <>
      <Helmet>
        <title>Agency Marketing | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="dashboard"
        tabBarItems={[
          {
            href: agencyMarketingIndexUrl,
            icon: faHome,
            key: 'dashboard',
            title: 'Dashboard',
          },
        ]}
        title="Agency Marketing"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyMarketing.dashboard.banner" />

            <LoadingModule loading={loading} times={3} />

            {!loading && (
              <>
                <TagSearch callbacks={{ selectTag }} />

                <FeaturedTags agencyMarketingPayload={agencyMarketingPayload} />

                <AllTags agencyMarketingPayload={agencyMarketingPayload} />
              </>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyMarketing.dashboard.sidebar" />

            <RecentCampaigns />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
